<template>
  <div>
    <div id="layoutSidenav_nav">
      <div class="sb-sidenav accordion sb-sidenav-light" id="sidenavAccordion">
        <div class="sb-sidenav-menu my-4">
          <div class="nav">
            <SideMenuItem v-for="(elem,idx) in getMenu" :key="idx" :item="elem"></SideMenuItem>
          </div>
        </div>
        <div @click="onClickLocation" class="sb-sidenav-footer ">
          <div role="button">
            <div class="small">Standort:</div>
            {{ getLocationName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SideMenuItem from './SideMenuItem'

  export default {
    name: 'SideMenu',
    components: {
      SideMenuItem
    },
    data () {
      return {
        menu: []
      }
    },
    methods: {
      onClickLocation () {
        this.$bvModal.show('locationChooser')
      }
    },
    computed: {
      getMenu () {
        return this.$store.getters['menu/getMenu']
      },
      getLocations () {
        return this.$store.getters.getLocations
      },
      getLocationName () {
        return (this.$store.getters.getLocation !== undefined) ? this.$store.getters.getLocation.sName : ''
      }
    },
    async created () {
      await this.$store.dispatch('menu/fetchMenu')
      await this.$store.dispatch('fetchLocations')
    }
  }
</script>

<style scoped>

</style>
